import convert from 'convert-units';
import moment from 'moment';
import { UNITS_OF_MEASURE } from './cult_constants';
/**
* packageForm(): Packages form element values with dashes in ids
* @param {String} id, id of form
* @returns {Object} formObj, key value form object
* @called-in: ['/components/chemical/chemical_form.js]
**/
export function packageForm(id) {
  let elements = document.getElementById(`${id}`).elements;
  let formObj = {};
  // eslint-disable-next-line
  for (let i = 0, element; element = elements[i++];) {
    if (element.id === "") continue;
    if (element.id.split('-').length === 2) {
      if (element.checked) formObj[element.name.split('-')[1]] = element.value;
      else if (element.type === 'radio' && !element.checked) continue;
      else if (element.type === 'checkbox' && !element.checked) continue;
      else formObj[element.id.split('-')[1]] = element.value;
    }
  }

  return formObj;
}
/**
* fillForm(): Pre-fills form
* @param {String} formId, id of form
* @param {Object} formData, data to prefill into form
* @returns
* @called-in: ['/components/chemical/chemical_form.js]
**/
export function fillForm(formId, formData) {
  let editForm = document.getElementById(formId).elements;
  // eslint-disable-next-line
  for (let i = 0, element; element = editForm[i++];) {
    if (element.id === "") continue;
    let id = element.id.split('-')[1];
    for (let key in formData) {
      if (key === id) {
        if (element.type === 'file') continue;
        if (element.type === 'date') element.value = formData[key].split('T')[0];
        else element.value = formData[key];
      }
      // Chemical Application
      if (element.id === 'chemApp-kau' && formData[key] === 71) element.checked = true;
      if (element.id === 'chemApp-keaau' && formData[key] === 72) element.checked = true;
      if (element.id === 'chemApp-isCompleteYes' && key === 'isComplete') {
        if (formData[key] === 1) element.checked = true;

      }
      if (element.id === 'chemApp-isCompleteNo' && key === 'isComplete') {
        if (formData[key] === 0) element.checked = true;
      }
      if (element.id === 'chemApp-methodAirblast' && formData[key] === 'Airblast') element.checked = true;
      if (element.id === 'chemApp-methodBroadcast' && formData[key] === 'Broadcast') element.checked = true;
      if (element.id === 'chemApp-methodSpot' && formData[key] === 'Spot') element.checked = true;
      // Fertilizer
      if (element.id === 'fert-kau' && Number(formData[key]) === 71) element.checked = true;
      if (element.id === 'fert-keaau' && Number(formData[key]) === 72) element.checked = true;
      if (element.id === 'fert-isCompleteYes' && key === 'isComplete') {
        if (formData[key] === 1) element.checked = true;
      }
      if (element.id === 'fert-isCompleteNo' && key === 'isComplete') {
        if (formData[key] === 0) element.checked = true;
      }
      // Mowing
      if (element.id === 'mow-kau' && Number(formData[key]) === 71) element.checked = true;
      if (element.id === 'mow-keaau' && Number(formData[key]) === 72) element.checked = true;
      if (element.id === 'mow-isCompleteYes' && key === 'isComplete') {
        if (formData[key] === 1) element.checked = true;
      }
      if (element.id === 'mow-isCompleteNo' && key === 'isComplete') {
        if (formData[key] === 0) element.checked = true;
      }
      // Tree Inventory
      if (element.id === 'treeInvEdit-kau' && Number(formData[key]) === 71) element.checked = true;
      if (element.id === 'treeInvEdit-keaau' && Number(formData[key]) === 72) element.checked = true;
      if (element.name === 'treeInvEdit-approver' && key === 'approver') {
        if (formData[key] === element.value) element.checked = true;
      }
      if (element.id.match(/treeReplant[0-9]-kau/) && Number(formData[key]) === 71) element.checked = true;
      if (element.id.match(/treeReplant[0-9]-keaau/) && Number(formData[key]) === 72) element.checked = true;
    }
  }
  return;
}
/**
* handleRecommendedDosage(): Pre-fills form
* @param {r} recommended dosage
* @returns
* @called-in: ['cult_utils']
**/
export function handleRecommendedDosage(r) {
  if (r === null || r === '') return;
  let rec1 = document.getElementById('chemical-recoDosage1');
  let rec2 = document.getElementById('chemical-recoDosage2');
  let rec3 = document.getElementById('chemical-recoDosage3');
  let rec4 = document.getElementById('chemical-recoDosage4');
  let rec = r.split(' ');
  rec1.value = rec[0];
  rec2.value = rec[1];
  rec3.value = rec[3];
  rec4.value = rec[4];
  return;
}
/**
* handleMaxQuantity(): Pre-fills form
* @param {r} maxQuantity
* @returns
* @called-in: ['cult_utils']
**/
export function handleMaxQuantity(r) {
  if (r === null || r === '') return;
  let rec1 = document.getElementById('chemical-maxQuantity');
  let rec2 = document.getElementById('chemical-maxQuantityUnit');
  let rec = r.split(' ');
  rec1.value = rec[0];
  rec2.value = rec[1];
  return;
}
/**
* resetForm(): Resets a form
* @param {String} formId, id of form
* @returns
* @called-in: ['/components/chemical/chemical_form.js]
**/
export function resetForm(id) {
  document.getElementById(id).reset();
  return;
}

/**
* determineIcon(): Determines the icon and color based on type
* @param {String} type, type of product
* @returns {Object} color, type
* @called-in: ['/components/chemical/product_view.js]
**/
export function determineIcon(type) {
  switch (type) {
    case 'Herbicide':
      return { color: 'green', icon: 'filter_vintage' };
    case 'Pesticide':
      return { color: 'red', icon: 'bug_report' };
    case 'Fertilizer':
      return { color: 'purple', icon: 'local_florist' };
    case 'Fungicide':
      return { color: 'grey', icon: 'colorize' };
    case 'Nutrient':
      return { color: 'cyan', icon: 'healing' };
    case 'Miticide':
      return { color: 'teal', icon: 'bug_report' };
    case 'Bactericide':
      return { color: 'light-green', icon: 'leak_add' };
    case 'Adjuvent':
      return { color: 'lime', icon: 'gradient' };
    default:
      return { color: 'light-blue', icon: 'folder' };
  }
}
/**
* mapEmployeeForAutoComplete(): Autocomplete function
* @param {Array} data, array of employees
* @returns {Object} object of names
* @called-in: ['/components/chemical/product_view.js]
**/
export function mapEmployeeForAutoComplete(data) {
  var dataObj = {};
  for (let i = 0; i < data.length; i++) {
    dataObj[`${data[i].firstName} ${data[i].lastName}`] = null;
  }
  return dataObj;
}

/**
* mapPropForAutoComplete(): Autocomplete function
* @param {Array} data, array of employees
* @returns {Object} object of names
* @called-in: ['/components/chemical/product_view.js]
**/
export function mapPropForAutoComplete(data, prop) {
  var dataObj = {};
  for (let i = 0; i < data.length; i++) {
    dataObj[data[i][prop]] = null;
  }
  return dataObj;
}

/**
* generateID(): Generates a unique general purpose ID
* @returns {String} uuid: unique id
* @called-in: ['/actions/chem_app_actions.js]
**/
export const generateID = () => {
  var d = new Date().getTime();
  if(window.performance && typeof window.performance.now === "function"){
      d += performance.now(); //use high-precision timer if available
  }
  var uuid = 'xxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (d + Math.random()*16)%16 | 0;
      d = Math.floor(d/16);
      // eslint-disable-next-line
      return (c=='x' ? r : (r&0x3|0x8)).toString(16);
  });
  return uuid;
};


export function checkApplicationForm(form) {
  for (let key in form) {
    if (key === 'notes' || key === 'comments') continue;
    if (form[key] === '') return true;
  }
  return false;
}

/**
* parseDosage(): Parses the recommended dosage: [number] [unit] / [number] [unit]
* @param {Object} chemicalList item
* @returns {Object} parsed values and units
* @called-in: ['/components/chem_app/chem_app_form.js]
**/
export function parseDosage(c) {
  if (c === undefined || c === null) return { num1: '', unit1: '', num2: '', unit2: '' };
  if (Object.keys(c).length === 0)  return { num1: '', unit1: '', num2: '', unit2: '' };
  let r = c.recoDosage.split(' ');
  return { num1: r[0], unit1: r[1], num2: r[3], unit2: r[4] };
}
/*
  Find a particular employee by first and last name
  returning only the find function will return duplicates every time.
  @called-in: ['/actions/harvest_actions.js']
*/
export function findEmployeeByName(name, employees) {
  if (!name) return { eid: '' };
  let emp;
  emp = employees.find((e) => `${e.firstName} ${e.lastName}` === name);
  return emp;
}
/**
* setDosage(): Sets the recommended dosage: [number] [unit] / [number] [unit] in a form
* @param {Object} chemicalList item
* @param {String} quantId: dom id of quantity
* @param {String} unitId: dom id of unit
* @param {String} totalId: dom id of total solution
* @returns
* @called-in: ['/components/chem_app/chem_app_form.js]
**/
export function setDosage({ dosage, quantId, unitId }) {
  document.getElementById(quantId).value = dosage.num1;
  document.getElementById(unitId).value = dosage.unit1;
  return;
}
/* Calculates the difference between two timestamps */
export function calculateHoursFromTime({ date, startTime, endTime }) {
  if (!(startTime && endTime)) return 0.00;
  let s = moment(`${date} ${startTime}`);
  let e = moment(`${date} ${endTime}`);
  return Math.abs(moment.duration(e.diff(s)).as('hours')).toFixed(2);
}
/* Calculates the percentage of a chemical used in a gallon based tanker */
export function calculatePercentage({ quantity, unit, totalGallons }) {
  if (!(quantity && unit) || totalGallons === 0) return 0.00;
  if (UNITS_OF_MEASURE.find((u) => u.value === unit && u.type === 'mass')) {
    return ((Number(quantity) / Number(totalGallons))*100).toFixed(5);
  }
  return ((Number(convert(quantity).from(unit).to('gal')) / Number(totalGallons))*100).toFixed(5);
}
/* Sums any measurement unit type to gallons */
export function convertToGalAndSum(arr) {
  if (!arr) return 0.00;

  if (arr[0].hasOwnProperty('chemDosage')) {
    let _total = arr.reduce((acc, cur) => {
      let n = cur.chemDosage.split(' ')[0];
      return acc + Number(n);
    }, 0);
    return _total;
  }

  let total = arr.reduce((acc, cur) => {
    if (UNITS_OF_MEASURE.find((u) => u.value === cur.chemDosage2 && u.type === 'mass')) return acc + 0;
    return acc + Number(convert(cur.chemDosage1).from(cur.chemDosage2).to('gal'));
  }, 0);
  return total;
}
/* Calculates the percentage of acres completed */
export function percentComplete(acresCompleted, totalAcres) {
  if (!(acresCompleted && totalAcres)) return 0.00;
  return (acresCompleted / totalAcres).toFixed(2);
}
/* Displays the balance of remaining acres */
export function handleBalance(previousHarvest, selectedField) {
  if (!(previousHarvest && selectedField)) return 0.0;
  let existingAcres = previousHarvest.reduce((acc, cur) => { return acc + cur.acresCompleted; }, 0);

  return (selectedField.mechHarvest - existingAcres).toFixed(2);
}
/* Calculates the acres completed based on tree count input */
export function acresBalance(acresCompleted, acresRemaining) {
  if (!(acresCompleted && acresRemaining)) return 0.00;
  return (Number(acresRemaining) - Number(acresCompleted)).toFixed(2);
}
/* Calculates acres per hour */
export function acresPerHour(hours, acres) {
  if (!(acres && hours)) return 0.00;
  return (Number(acres) / Number(hours)).toFixed(2);
}
/* Calculates tons per hour: Fertilizer */
export function tonsPerHour(tons, hours) {
  if (!(tons && hours)) return 0.00;
  return (Number(tons) / Number(hours)).toFixed(2);
}
/* Calculates tons per acre: Fertilizer */
export function tonsPerAcre(tons, acres) {
  if (!(tons && acres)) return 0.00;
  return (Number(tons) / Number(acres)).toFixed(2);
}
/* Sums a selected property of an array */
export function sumProp(prop, arr) {
  if (!(prop && arr)) return 0.00;
  let total = arr.reduce((acc, cur) => { return acc + Number(cur[prop]) }, 0);
  return total.toFixed(2);
}
/* Averages a selected property of an array */
export function avgProp(prop, arr) {
  if (!(prop && arr)) return 0.00;
  let total = arr.reduce((acc, cur) => { return acc + Number(cur[prop]) }, 0);
  return (total / arr.length).toFixed(2);
}
/* Dummy function */
export function onDummyComplete() {
  return;
}

/**
* filterOldRecords(): Filters records that are older than two weeks. Uses date property
* @param {Object} r: record with date prop
* @returns {Bool} filtered condition
* @called-in: ['/components/chem_app/chem_app_create.js]
**/
export function filterOldRecords(r) {
  return (Math.abs(moment(r.date).week() - moment().week()) <= 1);
}
/**
* filterArrayByPropAndValue(): Filters records by property and value
* @param {Object} r: record with date prop
* @returns {Bool} filtered condition
* @called-in: ['/components/tree_replant/tree_replant.js]
**/
export function filterArrayByPropAndValue(arr, prop, value) {
  return arr.filter((item) => {
    return item[prop] === value;
  });
}
/**
* uniqueElementsByRight(): Returns all unique values of an array, based on a provided comparator function, starting from the right.
* @param {Array} arr: array
* @param {Function} fn: function for comparison
* @returns {Bool} filtered condition
* @called-in: ['actions/fertilizer_actions.js'];
**/
export function uniqueElementsByRight(arr, fn) {
  return arr.reduceRight((acc, v) => {
    if (!acc.some(x => fn(v, x))) acc.push(v);
    return acc;
  }, []);
}



// WEBPACK FOOTER //
// ./src/cultivation/cult_utils.js